import { createRouter, createWebHashHistory } from 'vue-router'

import CreateReport from '../components/CreateReport.vue'
import FollowUp from '../components/FollowUp.vue'
import NotFound from '../components/NotFound.vue'

const router = createRouter({
  // linkExactActiveClass: 'active',
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      redirect: 'create'
    },
    {
      path: '/create',
      name: 'create_report',
      component: CreateReport,
      meta: {
        title: 'Puls - Create Report'
      },
      children: [
        {
          path: '/create/confirm',
          name: 'confirm_report',
          component: CreateReport,
          meta: {
            title: 'Puls - Confirm Report'
          }
        }
      ]
    },
    {
      path: '/followup',
      name: 'follow_up',
      component: FollowUp,
      meta: {
        title: 'Puls - Follow Up'
      }
    },
    { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFound }
  ]
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Puls'
  next()
})

export default router
